import { render, staticRenderFns } from "./InvitesUBA.vue?vue&type=template&id=5aafa037&scoped=true&"
import script from "./InvitesUBA.vue?vue&type=script&lang=js&"
export * from "./InvitesUBA.vue?vue&type=script&lang=js&"
import style0 from "./InvitesUBA.vue?vue&type=style&index=0&id=5aafa037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aafa037",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VDivider,VPagination,VRow,VSelect})
